import classNames from 'classnames';
import { BackgroundThemeRevision } from 'referral-types';
import GradientWavesBackground from '../../gradient-waves/GradientWavesBackground';

import '../_styles.scss';

export enum RainbowGradientSubThemeIds {
  waves = 'waves',
  horizontal = 'horizontal',
  diagonal4 = 'diagonal4',
}

export const RainbowGradientSubThemeOptions = [
  { value: RainbowGradientSubThemeIds.waves, label: 'Waves' },
  { value: RainbowGradientSubThemeIds.horizontal, label: 'Smooth Horizontal' },
  { value: RainbowGradientSubThemeIds.diagonal4, label: 'Diagonal 4' },
];

export const AnimatedRainbowGradient = (props: { themeRevision?: Partial<BackgroundThemeRevision> }) => {
  const { themeRevision } = props;
  let backgroundClass: string;

  if (themeRevision?.subTheme == RainbowGradientSubThemeIds.waves) {
    return <GradientWavesBackground />;
  }

  switch (themeRevision?.subTheme) {
    case RainbowGradientSubThemeIds.diagonal4:
      backgroundClass = 'animated-rainbow-gradient-diagonal4';
      break;
    case RainbowGradientSubThemeIds.horizontal:
    default:
      backgroundClass = 'animated-rainbow-gradient';
      break;
  }

  return <div className={classNames(backgroundClass, 'relative -z-10 h-full w-full')} />;
};
